<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-green">
          <div class="card-icon">
            <md-icon>assignment</md-icon>
          </div>
          <h4 class="title">Lista de Dispositivos</h4>
        </md-card-header>
        <md-card-content>
          <div class="text-right">
            <md-button class="md-primary md-dense"
                       @click="createDevice">
              Agregar Dispositivo
            </md-button>
            <md-field class="md-invalid">
              <md-input
                  v-model="searchPhone"
                  @keyup.enter="getDeviceByPhone"
                  placeholder="Buscar por teléfono"/>
              <validation-error :errors="apiValidationErrors.searchPhone"/>
            </md-field>
          </div>

          <md-table
              :value="table"
              :md-sort.sync="sortation.field"
              :md-sort-order.sync="sortation.order"
              :md-sort-fn="customSort"
              class="paginated-table table-striped table-hover"
          >

            <md-table-row slot="md-table-row" slot-scope="{ item }">

              <md-table-cell md-label="Proyecto" md-sort-by="project">
                {{ item.project.name }}
              </md-table-cell>

              <md-table-cell md-label="Tipo de Línea" md-sort-by="type_line">
                {{ item.typeLine.name }}
              </md-table-cell>

              <md-table-cell md-label="Teléfono" md-sort-by="phone">{{
                  item.phone
                }}
              </md-table-cell>

              <md-table-cell md-label="Fecha Creación" md-sort-by="created_at">{{
                  item.created_at
                }}
              </md-table-cell>
              <md-table-cell md-label="Acciones">

                <md-button
                    class="md-icon-button md-raised md-round md-info"
                    @click="onEdit(item.id)"
                    style="margin: 0.2rem"
                >
                  <md-icon>edit</md-icon>
                </md-button>

                <md-switch v-model="item.active"
                           :class="[item.active ? 'md-success' : 'md-danger' , 'bottom-10']"
                           @change="onActiveOrDeactivateDevice(item)">
                </md-switch>

                <md-button
                    class="md-icon-button md-raised md-round md-danger"
                    @click="onRemove(item)"
                    style="margin: 0.2rem"
                >
                  <md-icon>delete</md-icon>
                </md-button>
              </md-table-cell>
            </md-table-row>
          </md-table>

          <div class="footer-table md-table">
            <table>
              <tfoot>
              <tr>
                <th
                    v-for="item in footerTable"
                    :key="item.name"
                    class="md-table-head"
                >
                  <div class="md-table-head-container md-ripple md-disabled">
                    <div class="md-table-head-label">
                      {{ item }}
                    </div>
                  </div>
                </th>
              </tr>
              </tfoot>
            </table>
          </div>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class="">
            <p class="card-category">
              Mostrando {{ from + 1 }} de {{ to }} para {{ total }} resultados
            </p>
          </div>
          <Pagination
              class="pagination-no-border pagination-success"
              v-model="pagination.currentPage"
              :per-page="pagination.perPage"
              :total="total"
              @input="getDevices"
          />
        </md-card-actions>

      </md-card>
    </div>
  </div>
</template>

<script>

import Pagination from "@/components/Pagination";
import {ValidationError} from "@/components";
import formMixin from "@/mixins/form-mixin";
import globalId from "@/mixins/global-id";
import Swal from "sweetalert2";
import {get} from "lodash";

export default {
  name: "ListDevicePage",
  data: () => ({
    table: [],
    meta: {},
    footerTable: ["Proyecto", "Tipo de Línea", "Teléfono", "Fecha Creación", "Acciones"],
    sortation: {
      field: "created_at",
      order: "asc",
    },
    projects: [],
    typeLines: [],
    pagination: {
      perPage: 1,
      currentPage: 1,
      perPageOptions: [1, 5, 25, 50],
    },
    total: 1,
    searchPhone: null,
    activeOrDeactivate: true,
  }),
  components: {
    ValidationError,
    Pagination
  },
  mixins: [formMixin, globalId],
  computed: {
    sort() {
      if (this.sortation.order === "desc") {
        return `-${this.sortation.field}`;
      }

      return this.sortation.field;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },

    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
  },
  async created() {
    await this.getProjects();
    await this.getTypeLines();
    await this.getDevices();
    await this.getMeta();
  },
  methods: {
    async getProjects() {
      try {
        await this.$store.dispatch("projects/list");

        this.projects = await this.$store.getters["projects/list"]

      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        await this.$store.dispatch("alerts/error", `Oops, ${message}`);

        this.setApiValidation(e.response.data.errors)
      }
    },
    async getTypeLines() {
      try {
        await this.$store.dispatch("typeLines/list");

        this.typeLines = await this.$store.getters["typeLines/list"]

      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        await this.$store.dispatch("alerts/error", `Oops, ${message}`);

        this.setApiValidation(e.response.data.errors)
      }
    },
    async getDevices(page) {
      try {
        await this.$store.dispatch("devices/list", {page: page});

        let devices = await this.$store.getters["devices/list"];

        devices = devices.map(device => ({
          ...device,
          project: this.projects.find(project => project.id === device.project_id),
          typeLine: this.typeLines.find(typeLine => typeLine.id === device.type_line_id)
        }));

        this.table = devices;

      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        await this.$store.dispatch("alerts/error", `Oops, ${message}`);

        this.setApiValidation(e.response.data.errors)
      }
    },
    async getMeta() {
      this.meta = await this.$store.getters["devices/meta"];

      this.pagination.perPage = this.meta.per_page;
      this.pagination.currentPage = this.meta.current_page;
      this.total = this.meta.total;
    },
    async createDevice() {
      await this.$router.push({name: 'Create Device'})
    },
    async onEdit(modelId) {
      if(modelId){
        await this.$router.push({
          name: 'Edit Device',
          params: {deviceId: this.globalEncode(this.$route.meta.model, modelId)}
        });
      }
    },
    customSort() {
      return false;
    },
    async getDeviceByPhone() {
      try {
        if (this.searchPhone) {
          await this.$store.dispatch("devices/searchByPhone", {phone: this.searchPhone});

          let device = await this.$store.getters["devices/device"];
          this.table = [];

          if (device) {
            device = {
              ...device,
              project: this.projects.find(project => project.id === device.project_id),
              typeLine: this.typeLines.find(typeLine => typeLine.id === device.type_line_id)
            };

            this.table = [device];
          }

        }

      } catch (e) {
        let message = get(e.response.data.errors[0], 'detail');
        this.table = [];
        await this.$store.dispatch("alerts/error", `Oops, ${message}`);

        this.setApiValidation(e.response.data.errors);
      }
    },
    async onActiveOrDeactivateDevice(device) {
      Swal.fire({
        title: device.active ? 'Activar Dispositivo?' : 'Desactivar Dispositivo',
        text: device.active ? 'Estás seguro que quieres activar el dispositivo?' : 'Estás seguro que quieres desactivar el dispositivo?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: device.active ? 'Si, Activar!' : 'Si, Desactivar!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("devices/update", device);
          Swal.close();
          this.$store.dispatch("alerts/success", device.active  ? 'El dispositivo se ha activado correctamente' : 'El dispositivo se ha desactivado correctamente')
        } else {
          device.active = !device.active
        }
      })
    },
    async onRemove(device) {
      Swal.fire({
        title: 'Eliminar Dispositivo?',
        text: 'Estás seguro que quieres eliminar el dispositivo?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si, Eliminar!',
        cancelButtonText: 'Cancelar'
      }).then((result) => {
        if (result.value) {
          this.$store.dispatch("devices/destroy", device.id);
          Swal.close();
          const index = this.table.findIndex(item => item.id === device.id);
          this.table.splice(index, 1);
          this.$store.dispatch("alerts/success", 'El dispositivo se ha eliminado correctamente')
        }
      })
    },
  },
  watch: {
    searchPhone: function (value) {
      if (!value) {
        this.getDevices();
      }
    }
  },
}
</script>

<style lang="scss" scoped>
#pro-feature {
  font-weight: bold;
}

.bottom-10 {
  bottom: 10px;
}

.md-switch {
  display: flex;
}
</style>
